import React, { useState, useEffect } from "react";
import { Form, Card } from "antd";
import { useNavigate } from "react-router-dom";
import "antd/dist/antd.css";
import "./RegisterFinal.scss";
import MainButton from "../../../components/MainButton";
import TextInput from "../../../components/TextInput";
import ConfirmModal from "../../../components/ConfirmModal";
import {
  registerData,
  verifyMobile,
} from "../../../api/apiStore/Register/Register";
import register3 from "../../../assets/img/img_register_step_03_n@2x.png";
import Loading from "../../../components/Loading/Loading.jsx";

export default function RegisterFinal() {
  const [confirmModalMsg, setConfirmModalMsg] = useState("");
  const [confirmModal, setConfirmModal] = useState({
    title: "提示",
    visible: false,
    isRegisterSucess: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const register1Value = JSON.parse(sessionStorage.getItem("register1"));
  const register2Value = JSON.parse(sessionStorage.getItem("register2"));
  const allRegisterData = { ...register1Value, ...register2Value };
  const memberMobile = register1Value.mobile;
  let navigate = useNavigate();
  const registerHandler = async (verifyCode) => {
    setIsLoading(true);
    const registerResp = await registerData({ ...allRegisterData, verifyCode });
    setIsLoading(false);
    if (registerResp.RC !== "C01") {
      setConfirmModal(() => {
        return { title: "提示", visible: true, isRegisterSucess: false };
      });
      setConfirmModalMsg(registerResp.result.Message);
    } else {
      if (registerResp.result.Code === "0") {
        sessionStorage.setItem("C_NO", registerResp.result.Data.C_NO);
        setConfirmModal(() => {
          return { title: "提示", visible: true, isRegisterSucess: true };
        });
        setConfirmModalMsg(registerResp.result.Message);
      } else {
        setConfirmModal(() => {
          return { title: "提示", visible: true, isRegisterSucess: false };
        });
        setConfirmModalMsg(registerResp.result.Message);
      }
    }
  };

  const verifyMobileHandler = async () => {
    setIsLoading(true);
    const verifyResp = await verifyMobile();
    setIsLoading(false);
    if (verifyResp.RC !== "C01") {
      setConfirmModal(() => {
        return { title: "提示", visible: true };
      });
      setConfirmModalMsg(verifyResp.result.Message);
    }
    return;
  };

  function onFinish() {
    form
      .validateFields()
      .then(async (values) => {
        registerHandler(values.verify);
      })
      .catch((error) => {
        const { errorFields } = error;
        const filterErrorMsg = errorFields.map((item) => {
          const { errors } = item;
          item.errors = [...new Set(errors)];
          return item;
        });
      });
  }

  const handleOk = () => {
    if (confirmModal.isRegisterSucess) {
      sessionStorage.setItem("isRegisterSucess", true);
      navigate("/login");
    }
    setConfirmModal({ title: "提示", visible: false, isRegisterSucess: false });
  };
  return (
    <div>
      <Loading isLoadingVisible={isLoading}></Loading>
      <Card type="inner" className="registerFinalPage-basic">
        <img style={{ width: "100%", height: "100%" }} src={register3} />
        <Form
          form={form}
          name="basic"
          autoComplete="off"
          validateTrigger="onSubmit"
        >
          <Form.Item
            name="verify"
            rules={[
              {
                required: true,
                message: "驗證碼為必填",
              },
            ]}
          >
            <TextInput title="請輸入簡訊驗證碼" placeholder="" />
          </Form.Item>
          <p style={{ margin: "1vh 0 1vh 0" }}>
            已寄送驗證碼至{memberMobile}
            ，若您未收到驗證碼，請按下方「重新寄送驗證碼」。
          </p>
          <MainButton buttonType="main" onClick={onFinish}>
            確定
          </MainButton>
          <MainButton buttonType="sub" onClick={verifyMobileHandler}>
            重新寄送驗證碼
          </MainButton>
          <MainButton
            buttonType="sub"
            onClick={() => {
              navigate("/resetPassword");
            }}
          >
            修改手機號碼
          </MainButton>
        </Form>
      </Card>
      {confirmModal.visible ? (
        <ConfirmModal
          title={confirmModal.title}
          setModalvisible={confirmModal.visible}
          setHandleOk={handleOk}
          msg={confirmModalMsg}
        />
      ) : null}
    </div>
  );
}
